<modal #modal [css-class]="'order-full'">
    <div class="modal-header">
        <h5 class="modal-title">Beløbsgrænse nået</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
            
        </button>
    </div>
    <div class="modal-body">
        <p>Det maksimale beløb for spil pr. måned er nået.</p>
        <p>For hver online bestilling gælder en beløbsgrænse på 3.000 kr. pr. aftale pr. måned.</p>
    </div>
    <div class="modal-footer">
        <app-opening-hours></app-opening-hours>
    </div>
</modal>
